<template>
  <v-container grid-list-md grid-list-xs>
    <v-layout row>
      <v-flex xs12><br/></v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs10 offset-xs1>
        <h2>MODPlug Random Song Title / Rock Band Name Generator</h2>
        <div class="text-xs-center">
          <p>Stuck on a title for your song? Need a crazy name for your band? Let the MODPlug Central title generator get
            your creative juices flowing with some randomly generated titles.</p>
          <p>Just click the GIVE ME A TITLE button and you will be presented with a random title:</p>
        </div>
      </v-flex>
      <v-flex xs10 offset-xs1 class="text-xs-center">
        <title-generator></title-generator>
      </v-flex>
      <v-flex xs10 offset-xs1 class="text-xs-center">
        <p>Just click on the button, and a song title (or band name - you be the judge) will appear in the box. Some of
          them may not make much sense, such as "Violent Violence", but you may like them anyway. You may even recognize
          the title of a popular song appearing, which may make you question where they got the title from in the first
          place... You can click on the button as much as you wish for a new randomly generated song title. (Remember -
          this is a randomly generated title and most likely won't make a whole lot of sense, but hopefully it will kick
          your mind into a creative mode)
        </p>
      </v-flex>
    </v-layout>
  </v-container>
</template>


<script>
  import TitleGeneratorForm from '@/components/includes/randomTitleGeneratorForm';
  export default {
    name: 'title-generator-page',
    title: 'MODPlug Central - Random Song Title Generator, Random Band Name Generator',
    components: {
      'title-generator' : TitleGeneratorForm
    }
  }
</script>

<style scoped>
  h2 {
    min-height: 3em;
    @media (max-width: 468px) {

    }
  }
</style>